<template>
  <div class="personal-center">
    <div class="personal-top">
        <div class="top-bg"></div>
        <div class="head-portrait"></div>
        <div class="personal-top-name">
            <div>{{ nickname | defaultValFilter }}</div>
        </div>
    </div>
    <div class="personal-bottom">
        <div class="message">
            <div class="details">
                <span class="details-left">&nbsp;&nbsp;&nbsp;&nbsp;用户名：</span>
                <span class="details-right">{{ nickname | defaultValFilter }}</span>
            </div>
            <div class="details">
                <span class="details-left">用户类型：</span>
                <span class="details-right">{{ customer | defaultValFilter }}</span>
            </div>
            <div class="details">
                <span class="details-left">有效时间：</span>
                <span class="details-right">{{ expired_time | defaultValFilter }}</span>
            </div>
            <div class="btn">
                <el-button @click="changePassword">修改密码</el-button>
            </div>
        </div>
    </div>
    <!-- 修改密码 -->
    <el-dialog
		:visible.sync="passwordDialog"
        @close="cancelClick"
        customClass="password-dialog"
		width="934px"
		>
        <p class="title">修改密码</p>
        <div class="tips-txt" v-if="type=='新'">尊敬的腾云用户您好，为了您的账户安全，首次登录请修改个人密码！</div>
        <div class="line"></div>
        <div class="content">
            <div class="row-details">
                <span class="star">*</span>
                <span class="details-title">原始密码：</span>
                <el-input v-model="pass_old" show-password placeholder="请输入原始密码"></el-input>
            </div>
            <div class="row-details">
                <span class="star">&nbsp;&nbsp;&nbsp;&nbsp;*</span>
                <span class="details-title">新密码：</span>
                <el-input v-model="password" show-password placeholder="包含数字和大小写字母，不超过16位"></el-input>
            </div>
            <div class="row-details">
                <span class="star">*</span>
                <span class="details-title">确认密码：</span>
                <el-input v-model="pass_confirm" show-password placeholder="包含数字和大小写字母，不超过16位"></el-input>
            </div>
            <div class="parameter-btn">
                <el-button class="cancel" @click="cancelClick()">取消</el-button>
                <el-button class="confirm" @click="confirmClick()">确认</el-button>
            </div>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
export default {
  data() {
    return {
        passwordDialog:true,
        nickname: '',
        customer: '',
        input: '',
        expired_time: '',
        password:"",
        pass_old:"",
        pass_confirm:"",
        type:"",
    };
  },
  mounted() {
    this.$nextTick(function() {
        if(localStorage.getItem("type") == "新"){
            this.passwordDialog = true;
        } else if(localStorage.getItem("type") == "旧") {
            this.passwordDialog = false;
        }
        this.type = localStorage.getItem("type");
        this.nickname = localStorage.getItem("nickname");
        let num = localStorage.getItem("is_customer");
        if(num == 1){
            this.customer = "集团用户";
        } else if(num == 0){
            this.customer = "普通用户";
        }
        this.expired_time = localStorage.getItem("expired_time");
    });
  },
  beforeRouteEnter(to, from, next) {
    window.document.querySelector("body").setAttribute("style", "background-image:none");
    window.document.body.style.backgroundColor = "#f3f4f6";
    next();
  },
  beforeRouteLeave(to, from, next) {
    window.document.body.style.backgroundColor = "#001928";
    next();
  },
  methods: {
    cancelClick(){
        this.passwordDialog = false;
        this.password = "";
        this.pass_old = "";
        this.pass_confirm = "";
    },
    confirmClick(){
        if(!isPassWord(this.password)) {
            this.$message.warning("请输入正确新密码格式！");
            return;
        } else if(!isPassWord(this.pass_confirm)) {
            this.$message.warning("请输入正确确认密码格式！");
            return;
        }
        let params = {
          id: localStorage.getItem("newid"),
        //   token: localStorage.getItem("token"),
          password:this.password,
          pass_old:this.pass_old,
          pass_confirm:this.pass_confirm,
      };
      this.$api({
          method: "post",
          url: "/api.php/Index/passwordReset",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                this.$router.push('/login');
                this.$message.success(su.data.message);
                this.passwordDialog = false;
                this.password = "";
                this.pass_old = "";
                this.pass_confirm = "";
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                this.$router.push('/login');
                this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                  this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    changePassword(){
        this.passwordDialog = true;
    },
  }
};
</script>

<style lang='scss' scoped>
.personal-center {
    .personal-top {
        width: 100%;
        height: 300px;
        background-color: #ffffff;
        position: relative;
        .top-bg {
            width: 100%;
            height: 150px;
            background: url(../../assets/img/personal.jpg) no-repeat;
            background-size: 100% 100%;
        }
        .head-portrait {
            width: 134px;
            height: 134px;
            border-radius: 50%;
            border: 6px solid #e1e1e1;
            position: absolute;
            top:50%;
            left: 50%;
            margin-top: -67px;
            margin-left: -67px;
            background: url(../../assets/img/touxiang.png) no-repeat;
            background-size: 100% 100%;
        }
        .personal-top-name {
            width: 200px;
            position: absolute;
            bottom:10%;
            left: 50%;
            margin-left: -90px;
            div {
                text-align: center;
                color: #333333;
                font-size: 18px;
            }
        }
    }
    .personal-bottom {
        width: 100%;
        height: 500px;
        background-color: #f3f4f6;
        .message {
            margin-top: 6%;
            .details {
                margin-bottom: 26px;
                vertical-align: top;
                .details-left {
                    line-height: 44px;
                    vertical-align: top;
                    color: #323335;
                }
                .details-right {
                    display: inline-block;
                    width: 22%;
                    height: 44px;
                    background-color: #ffffff;
                    vertical-align: top;
                    color: #747474;
                    line-height: 44px;
                    text-align: left;
                    padding-left: 10px;
                }
            }
            .btn {
                .el-button {
                    width: 22.4%;
                    height: 54px;
                    background-color: #0076be;
                    border:none;
                    color:#ffffff;
                    margin-left: 87px;
                    font-size: 16px;
                }
            }
        }
    }
    .password-dialog {
        position: relative;
        overflow-x: hidden;
        .title {
            font-size: 18px;
            position: absolute;
            left: 16px;
            top:16px;
            color: #0171BD;
        }
        .tips-txt {
            color: #eb0000;
            text-align: center;
        }
        .line {
            width: calc(100% + 40px);
            margin-left: -20px;
            margin-right: -20px;
            height: 1px;
            margin-top: 14px;
            background-color: #EAEAEA;
            margin-bottom: 30px;
        }
        .content {
            .row-details {
                margin-bottom: 16px;
                .star {
                    color: #ec0000;
                }
                .details-title {}
                .el-input {
                    width: 33%;
                }
            }
            .parameter-btn {
                margin-top: 40px;
                .cancel {
                    width: 20%;
                    background-color: #0071BD;
                    color:#ffffff;
                    border:none;
                    height: 50px;
                }
                .confirm {
                    width: 20%;
                    background-color: #02B36F;
                    color:#ffffff;
                    border:none;
                    height: 50px;
                }
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/login/personalCenter.vue